import { useEffect, useRef, useState } from 'react';
import useDocumentTitle from '../../../../hooks/useDocumentTitle';
import { useParams } from 'react-router-dom';
import { ProductsService } from '../../../../services/ProductsService';
import { ToasterService } from '../../../../services/ToasterService';
import { useNavigate } from 'react-router-dom';
import { useLoader } from '../../../../context/LoaderContext';

export default function UseProductDetailsPage() {
  const navigate = useNavigate();
  const quotation_items = localStorage.getItem('quotation_items');
  const userLoginData = localStorage.getItem('userLoginData');
  // useDocumentTitle('Namasteji Manikchand - Product Details');
  const { itemCode } = useParams();
  const [thumbnails, setThumbnails] = useState<any[]>([]);
  const [mainImage, setMainImage] = useState<any | null>(null);
  const [thumbIndex, setThumbIndex] = useState(0);
  const [isManualSelect, setIsManualSelect] = useState(true);
  const [quantity, setQuantity] = useState(1);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [scrollDirection, setScrollDirection] = useState<'up' | 'down' | null>(null);
  const [productInfo, setProductInfo] = useState<any>([]);
  const [cartItems, setCartItems] = useState<any[]>([]);
  const [cartDataArr, setCartDataArr] = useState<any[]>([]);
  const packOfValue = useRef<any>(0);
  const productPointDesc = useRef<any>([]);
  const accordionItems = useRef<any>([]);
  const relatedItems = useRef<any>([]);
  const updated_quotation_items = useRef<any>([]);
  const parsedUserLoginData = useRef<any>({});
  const { loading, setLoading } = useLoader();
  const itemCartExistingQty = useRef<any>(0);
  const listOfCoupen = useRef<any>([]);
  const appliedCouponName = useRef<string>(null);
  const [inputCode, setInputCode] = useState('');
  const [showCoupenModalMobile, setShowCoupenModalMobile] = useState<boolean>(false);
  const customerId = useRef('');

  useEffect(() => {
    if (itemCode) {
      getProductDetails(itemCode); // <-- reload jab bhi param change ho
    }
    if (quotation_items) {
      updated_quotation_items.current = JSON.parse(quotation_items);
    }
    if (userLoginData) {
      parsedUserLoginData.current = JSON.parse(userLoginData);
      if (
        parsedUserLoginData.current &&
        parsedUserLoginData.current.customer_id &&
        parsedUserLoginData.current.customer_id !== ''
      ) {
        customerId.current = parsedUserLoginData.current.customer_id;
      }
    }
    handleThumbnailsUpDown();
  }, [itemCode]);

  function handleThumbnailsUpDown() {
    if (!isManualSelect && thumbnails.length > 0) {
      const visibleThumb = thumbnails.slice(thumbIndex, thumbIndex + 4);
      if (visibleThumb.length > 0) {
        if (scrollDirection === 'up') {
          setMainImage(visibleThumb[visibleThumb.length - 1]);
        } else {
          setMainImage(visibleThumb[0]);
        }
      }
    }
  }

  async function getProductDetails(itemCodes: any) {
    if (itemCodes && itemCodes !== '') {
      try {
        setLoading(true);
        const resp = await ProductsService.Details(itemCodes);
        if (resp && resp.status_code === 200) {
          setLoading(false);
          const apiResp = resp;
          const productInfo = apiResp.data.product_info;

          if (Object.keys(productInfo).length > 0) {
            const productContent = apiResp.data.content;
            const recommendedItems = apiResp.data?.recommended_items;
            packOfValue.current = productInfo?.uom_conversion[0]?.conversion_factor;
            productPointDesc.current = productInfo?.description?.split('\n');
            accordionItems.current = productContent?.content;
            relatedItems.current = recommendedItems?.recommended;
            if (updated_quotation_items.current.length > 0) {
              const allreadyQuot = updated_quotation_items.current?.find((item: any) => item.item_code === itemCode);
              if (allreadyQuot) {
                itemCartExistingQty.current = allreadyQuot.qty;
                setQuantity(allreadyQuot.qty);
              }
            }

            setMainImage(apiResp.data.slideshow[0]);
            setThumbnails(apiResp.data.slideshow);
            setProductInfo(productInfo);
          } else {
            ToasterService.Error('Product Not found..');
            // navigate(`/products`);
            navigate(-1);
          }
        } else {
          setLoading(false);
          ToasterService.Error('Something went wrong. Try again after some time');
          // navigate(`/products`);
          navigate(-1);
        }
      } catch (err) {
        setLoading(false);
        ToasterService.Error('Server Error!...');
      }
    } else {
      // navigate(`/products`);
      navigate(-1);
    }
  }

  // const cartItemPlusMinus = async (qyt: any, item_code: any, callFor: string) => {
  //     try {
  //         const payload = {
  //             item_code: item_code,
  //             qty_status: callFor
  //         }

  //         console.log(payload)
  //         const resp = await ProductsService.ItemQytPlusMinusNew(payload);
  //         if (resp && resp.status_code == 200) {
  //             const updated_quotation_items = resp.data?.cart?.items
  //             console.log('quotation_items quotation_itemsquotation_items', updated_quotation_items)

  //             localStorage.setItem('quotation_items', JSON.stringify(updated_quotation_items))
  //             setCartItems(updated_quotation_items)
  //             setCartDataArr(resp.data?.cart)

  //             if (item_code == itemCode && callFor == 'plus') {
  //                 setQuantity(quantity + 1);
  //             } else if (item_code == itemCode && callFor == 'minus') {
  //                 setQuantity(Math.max(1, quantity - 1));
  //             }

  //         } else {
  //             ToasterService.Error("Something Else try again sometime")
  //         }
  //     } catch (error) {
  //         // console.log(error)
  //         ToasterService.Error('Server Error!..')
  //     }
  // };

  const cartItemPlusMinus = async (qyt: any, item_code: any, callFor: string) => {
    try {
      let updatedQyt = qyt;
      if (callFor === 'plus') {
        updatedQyt = qyt + 1;
      } else if (callFor === 'minus') {
        updatedQyt = qyt - 1;
      }
      const payload = {
        customer_id: parsedUserLoginData.current.customer_id,
        items: [
          {
            item_code: item_code,
            qty: updatedQyt,
          },
        ],
      };
      const resp = await ProductsService.AddToCart(payload);
      if (resp && resp.status_code && resp.status_code === 200) {
        const updated_quotation_items = resp.data?.cart?.items;
        localStorage.setItem('quotation_items', JSON.stringify(updated_quotation_items));
        setCartItems(updated_quotation_items);
        setCartDataArr(resp.data?.cart);
        if (item_code === itemCode && callFor === 'plus') {
          setQuantity(quantity + 1);
        } else if (item_code === itemCode && callFor === 'minus') {
          setQuantity(Math.max(1, quantity - 1));
        }

        if (resp.data.list_of_coupon && resp.data.list_of_coupon.length > 0) {
          listOfCoupen.current = resp.data.list_of_coupon;
        }
        if (resp.data.apply_coupon_code && resp.data.apply_coupon_code !== null) {
          appliedCouponName.current = resp.data.apply_coupon_code?.coupon_name;
        } else {
          appliedCouponName.current = null;
        }
      } else if (
        resp &&
        resp.message &&
        resp.message.status_code &&
        resp.message.status_code === 200 &&
        resp.message.deleted === true
      ) {
        setIsCartOpen(false);
        itemCartExistingQty.current = 0;
        localStorage.removeItem('quotation_items');
      } else {
        ToasterService.Error('Something Else try again sometime');
      }
    } catch (error) {
      // console.log(error)
      ToasterService.Error('Server Error!..');
    }
  };

  const openIsCartPopup = async (itemCode: any) => {
    if (parsedUserLoginData && parsedUserLoginData.current.customer_id) {
      try {
        setLoading(true);
        const payload = {
          customer_id: parsedUserLoginData.current.customer_id,
          items: [
            {
              item_code: itemCode,
              qty: quantity,
            },
          ],
        };
        const resp = await ProductsService.AddToCart(payload);
        setLoading(false);
        if (resp && resp.status_code && resp.status_code === 200) {
          const updated_quotation_items = resp.data?.cart?.items;
          if (resp.data.list_of_coupon && resp.data.list_of_coupon.length > 0) {
            listOfCoupen.current = resp.data.list_of_coupon;
          }
          if (resp.data.apply_coupon_code && resp.data.apply_coupon_code !== null) {
            appliedCouponName.current = resp.data.apply_coupon_code?.coupon_name;
          } else {
            appliedCouponName.current = null;
          }
          const currentCartQuot = updated_quotation_items?.find((item: any) => item.item_code === itemCode);
          if (currentCartQuot) {
            itemCartExistingQty.current = currentCartQuot.qty;
            setQuantity(currentCartQuot.qty);
          }
          localStorage.setItem('quotation_items', JSON.stringify(updated_quotation_items));
          setCartItems(updated_quotation_items);
          setCartDataArr(resp.data?.cart);
          setIsCartOpen(true);
        } else {
          ToasterService.Error('Something Else try again sometime');
        }
      } catch (err) {
        setLoading(false);
        ToasterService.Error('Server Error!..');
      }
    } else {
      navigate('/login');
    }
  };

  function whatsApp(itemCode: string) {
    const shareItemUrl = window.location.origin + '/product/details/' + itemCode;
    const message = `Check out this product:\n${shareItemUrl}`;
    window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, '_blank');
  }

  function facebook(itemCode: string) {
    const shareItemUrl = window.location.origin + '/product/details/' + itemCode;
    const encodedUrl = encodeURIComponent(shareItemUrl);
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
    window.open(facebookUrl, '_blank');
  }

  function copyLink(itemCode: string) {
    const shareItemUrl = window.location.origin + '/product/details/' + itemCode;
    navigator.clipboard
      .writeText(shareItemUrl)
      .then(() => {
        ToasterService.Success('Link copied to clipboard');
      })
      .catch(err => {
        ToasterService.Error('Failed to copy');
      });
  }
  function linkedin(itemCode: string) {
    const shareItemUrl = window.location.origin + '/product/details/' + itemCode;
    const encodedUrl = encodeURIComponent(shareItemUrl);
    const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
    window.open(linkedInUrl, '_blank');
  }

  function goToProductDetailsPage(itemCode: string) {
    if (itemCode && itemCode !== '') {
      itemCartExistingQty.current = 0;
      setQuantity(1);
      navigate(`/product/details/${itemCode}`);
    }
  }

  const handleApply = async (code: string) => {
    setInputCode(code);
    try {
      setLoading(true);
      const resp = await ProductsService.ApplyCoupon(parsedUserLoginData.current.customer_id, code);
      setLoading(false);
      if (resp && resp.data) {
        if (resp && resp.data && resp.data.cart && Object.keys(resp.data.cart).length > 0) {
          if (resp.data.list_of_coupon && resp.data.list_of_coupon.length > 0) {
            listOfCoupen.current = resp.data.list_of_coupon;
          }
          if (resp.data.apply_coupon_code && resp.data.apply_coupon_code !== null) {
            appliedCouponName.current = resp.data.apply_coupon_code?.coupon_name;
          }
          setCartDataArr(resp.data?.cart);
          setShowCoupenModalMobile(false);
          ToasterService.Success('Coupon Applied Successfully!');
        }
      } else {
        ToasterService.Error('Temporary issue, try again later.');
        navigate('/product/cart');
      }
    } catch (err) {
      setLoading(false);
    }
  };

  const handleRemoveCoupon = async () => {
    try {
      setLoading(true);
      const resp = await ProductsService.RemoveCoupen(parsedUserLoginData.current.customer_id, 1);
      setLoading(false);
      if (resp && resp.data) {
        if (resp && resp.data && resp.data.cart && Object.keys(resp.data.cart).length > 0) {
          if (resp.data.list_of_coupon && resp.data.list_of_coupon.length > 0) {
            listOfCoupen.current = resp.data.list_of_coupon;
          }
          if (resp.data.apply_coupon_code && resp.data.apply_coupon_code !== null) {
            appliedCouponName.current = resp.data.apply_coupon_code?.coupon_name;
          } else {
            appliedCouponName.current = null;
          }
          setCartDataArr(resp.data?.cart);
          setShowCoupenModalMobile(false);
          setInputCode('');
          ToasterService.Success('Coupon Removed Successfully!');
        }
      } else {
        ToasterService.Error('Temporary issue, try again later.');
        navigate('/home');
      }
    } catch (err) {
      setLoading(false);
    }
  };

  const states = {
    packOfValue,
    productInfo,
    productPointDesc,
    accordionItems,
    relatedItems,
    itemCartExistingQty,
  };
  const shareProduct = {
    whatsApp,
    facebook,
    copyLink,
    linkedin,
  };

  const couponObj = {
    listOfCoupen,
    inputCode,
    showCoupenModalMobile,
    setShowCoupenModalMobile,
    appliedCouponName,
    handleRemoveCoupon,
    handleApply,
  };

  return {
    thumbnails,
    thumbIndex,
    states,
    setThumbIndex,
    setScrollDirection,
    setIsManualSelect,
    setMainImage,
    mainImage,
    setQuantity,
    quantity,
    setIsCartOpen,
    isCartOpen,
    cartItems,
    openIsCartPopup,
    cartDataArr,
    cartItemPlusMinus,
    shareProduct,
    goToProductDetailsPage,
    couponObj,
    navigate,
    customerId,
  };
}
